@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../constants/spacing.module.less';

.modal-content {
  gap: @space-4;
  margin: @space-4 @space-0;
}

.setter-wrapper {
  align-items: center;
  justify-content: space-between;
}

.slider {
  > label {
    > span {
      // there is no way to override this without messing with generic component
      font-size: 16px !important;
    }
  }
}

.input-setter {
  width: unset;
  flex: 1;
  max-width: 74px;
}

.input-setter-error {
  border: 1px solid var(--red-600);
  &:hover,
  &:focus,
  &:active,
  &:focus-within {
    border: 1px solid var(--red-600);
  }
}

.input-setter-row {
  align-items: center;
  gap: @space-8;
}

.input-label-error {
  color: var(--red-600);
}

.input-info {
  margin-top: @space-8;
  color: var(--grey-600);
}

.slider-column {
  flex: 9;
  margin-top: @space-8;
  margin-right: @space-16;
}

.input-column {
  flex: 2;
}

.checkbox-column {
  flex: 1;
  justify-content: center;
}

.warehouse-dropdown-column {
  flex: 55;
}

.min-max-hr {
  margin-top: @space-24;
}
